import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import PipelineListByMission from '../pipeline/PipelineListByMission'
import { useSelector } from 'react-redux'
import { AppDispatch, RootState, useAppDispatch } from '../../redux/store'
import { getMissionbyId } from '../../redux/missions/missionActions'
import BreadcrumbsComponent from '../../components/common/GlobalBreadcrumb'
import { t } from 'i18next'

function PipelinesByMissionId() {
  const { id } = useParams<{ id: string }>()
  const dispatch: AppDispatch = useAppDispatch()

  const Mission = useSelector((state: RootState) => state.mission.mission)
  useEffect(() => {
    if (id) {
      dispatch(getMissionbyId(id))
    }
  }, [dispatch, id])
  const breadcrumbs = [
    {
      label: `Mission ${Mission?.MissionName} `,
      path: `/mission-details/${id}`,
    },
    { label: t('tables.pipelineTable.title'), path: '' },
  ]
  return (
    <div>
      <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
      <PipelineListByMission IdMission={id || ''} />
    </div>
  )
}

export default PipelinesByMissionId
